<template>
    <v-row v-if="loading" dense>
        <v-col>
            <v-card
                class="mt-4"
                outlined>
                <v-card-text>
                    <loading-linear message="Loading Relevant Graphics ...">
                    </loading-linear>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
    <div v-else>
        <divider-expand
            v-if="displaySection && !isMobilePort"
            :open-by-default="defaultExpand"
            :activateSearchTab="this.$getConst('graphicsSearchType')"
            buttonText="See More Graphics">
            <p class="fs-14 mb-0 d-inline font-weight-medium">
                Relevant Graphics (Beta)
            </p>
            <template v-slot:expand>
                <v-row dense>
                    <v-col v-for="(item, key) in results" :key="key">
                        <v-card class="fill-height" @click="getGraphicDetails(item)" outlined>
                            <div
                                @contextmenu="(event) => handleRightClick(event, item.document_sku)"
                                class="img-block-height d-flex justify-center align-center"
                            >
                                <v-avatar
                                    color="white"
                                    size="20"
                                    style="position: absolute; z-index: 2; top: 2px; right: 2px;">
                                    <access-icon :access-level="getAccessLevel(item.document_sku, item.content_access_level_id)">
                                    </access-icon>
                                </v-avatar>
                                <img
                                    :src="item.figure_url"
                                    :alt="item.alt_text.length > 0 ? item.alt_text : `${item.section_title} Graphic`"
                                    @error="loadPlaceholderImage"
                                    height="50"
                                    width="50"
                                />
                            </div>
                            <v-divider></v-divider>
                        </v-card>
                    </v-col>
                </v-row>
            </template>
        </divider-expand>
    </div>

</template>

<script>
    import { mapState } from "vuex";
    import AccessIcon from "../../icons/AccessIcon.vue";
    import ConfirmDialog from "../../ConfirmDialog.vue";
    import LoadingLinear from "../../loaders/LoadingLinear.vue";
    import {EventNames} from "../../../classes/EventNames";
    import TabbedSearch from "../mixins/TabbedSearch";
    import DividerExpand from "../../expands/DividerExpand.vue";
    import Mobile from "../../inc/mixins/mobile";

    export default {
        name: 'GraphicSearchThumbnails',
        data() {
            return {
                defaultExpand: true,
            }
        },
        mixins: [
            TabbedSearch,
            Mobile
        ],
        components: {
            LoadingLinear,
            ConfirmDialog,
            AccessIcon,
            DividerExpand
        },
        computed: {
            ...mapState('GraphicsSearchModule', ['results', 'loading', 'searchTermId', 'displaySection']),
        },
        methods: {
            getAccessLevel(sku, contentAccessLevelId) {
                if (this.isPremiumSubscribed(sku)) {
                    return 'premiumActive';
                }

                if (this.isBasicAccessBook(contentAccessLevelId)) {
                    return 'basic';
                }

                return 'premium';
            },
            loadPlaceholderImage(e) {
                e.target.src = this.asset(require('../../../images/graphics_image_missing.png'));
            },
            handleRightClick(event, sku) {
                if (!this.isPremiumSubscribed(sku)) {
                    event.preventDefault();
                }
            },
            getGraphicDetails(item) {
                item.searchTermId = this.searchTermId;
                EventBus.fire(EventNames.GRAPHIC_DETAILS, item);
            }
        }
    }
</script>

<style scoped>
    .img-block-height {
        height: 80px;
        width: 105px;
        overflow: hidden;
    }
</style>